import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@cmps/ng-bootstrap';

import { AuthState } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';
import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../common/take-until-destroy.decorator';
import { rootInitResult } from '../insight-explorer/insight-explorer.action';
import { RootState as InsightExplorerRootState } from '../insight-explorer/insight-explorer.state';
import { TabType } from '../insight/tabset.model';
import store from '../store';

import { ActionType } from './debug-middleware/action-type';

@Component({
    selector: 'cmps-debug-panel',
    templateUrl: './panel.debug.component.html',
    styles: ['.fixed-bottom {left: auto; z-index: 999999}'],
    host: {
        '[style.display]': 'isVisible ? "block" : "none"',
        '(document:keydown)': 'onKeydown($event)',
    },
})
@TakeUntilDestroy()
export class DebugPanelComponent implements OnInit, OnDestroy {
    build: string = CMPS_APP_DEF.BUILD;
    isVisible: boolean;
    isCollapsed: boolean;
    nav: any;

    get hasSaml2AuthMethod(): boolean {
        try {
            return this._authService.user.hasSaml2AuthMethod();
        } catch (err) {}
        return false;
    }

    constructor(
        private readonly _modalService: NgbModal,
        private readonly _authService: AuthService,
    ) {
        this.isVisible = false;
        this.nav = [
            { name: 'admin > users > create', commands: 'admin/users' },
            { name: 'admin > users > edit', commands: 'admin/users/edit' },
            { name: 'insight-explorer', commands: ['insight-explorer'] },
            {
                name: 'scorecard_v2',
                commands: ['scorecard_v2'],
                queryParams: { demo: 1 },
            },
        ];
    }

    ngOnInit(): void {
        //
    }

    ngOnDestroy(): void {
        //
    }

    onKeydown($event: KeyboardEvent): void {
        if ($event.ctrlKey && $event.altKey && $event.keyCode === 68 /* d */) {
            this.isVisible = !this.isVisible;
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onMoveClick(n: HTMLElement, left: boolean) {
        n.style.left = !left ? 'auto' : '';
        n.style.right = left ? 'auto' : '';
    }

    onInvokeReAuthClick(): void {
        this._authService
            .refreshToken()
            .pipe(takeUntilDestroy(this))
            .subscribe();
    }

    onInvokeTimeoutClick(): void {
        this._authService.updateAuthStatus(AuthState.TIMEOUT);
    }

    onInvokeAuthLostClick(): void {
        this._authService.updateAuthStatus(AuthState.LOST);
    }

    onToggleSsoSimulationClick(): void {
        if (!this._authService.user.amr) return;
        const amr = this._authService.user.amr;
        const indexSim = amr.indexOf('SIMULATION');
        if (indexSim === -1) {
            amr.push('SIMULATION', 'saml2');
        } else {
            amr.splice(indexSim, 1);
            const index = amr.indexOf('saml2');
            if (index !== -1) {
                amr.splice(index, 1);
            }
        }
    }

    onDismissAllModalsClick(): void {
        this._modalService.dismissAll();
    }

    /* @deprecated. TODO remove */
    onAddPiTabClick(): void {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        const state = {
            ...(store.getState()[
                // eslint-disable-next-line @typescript-eslint/dot-notation
                'insightExplorer'
            ] as InsightExplorerRootState),
        };
        state.tabs.splice(-1, 0, {
            id: `pi${Math.random()}`,
            ctx: {
                type: TabType.PERFORMANCE,
                originalLabel: 'pi',
                label: 'pi',
                config: { identifier: '' },
            },
        });
        store.dispatch(rootInitResult(state));
    }

    /** @private */
    _onCoachingSummaryForAllFlowsClick($event: Event): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        $event && $event.preventDefault();
        sessionStorage.setItem('coaching-summary-for-all-flows', 'value');
    }

    /** @private */
    _onCoachingSummaryForAllFlowsClearClick($event: Event): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        $event && $event.preventDefault();
        sessionStorage.removeItem('coaching-summary-for-all-flows');
    }

    /** @private */
    _onRecordStartClick($event: Event): void {
        $event?.preventDefault();
        $event?.stopPropagation();
        store.dispatch({ type: ActionType.RECORD_START });
    }

    /** @private */
    _onRecordStopClick($event: Event): void {
        $event?.preventDefault();
        $event?.stopPropagation();
        store.dispatch({ type: ActionType.RECORD_STOP });
    }

    /** @private */
    _onRecordServeClick($event: Event): void {
        $event?.preventDefault();
        $event?.stopPropagation();
        store.dispatch({ type: ActionType.RECORD_SERVE });
    }

    /** @private */
    _onRecordClearClick($event: Event): void {
        $event?.preventDefault();
        $event?.stopPropagation();
        store.dispatch({ type: ActionType.RECORD_CLEAR });
    }
}
